export default __webpack_public_path__ + "static/media/colocado-1.95c02358.jpg";